import React from 'react'
import { Skeleton } from '@mui/material'
import { Container } from './styles'

export const SkeletonBigNumbers
 = () => {
  return (
    <Container>
      <Skeleton
        variant="rectangular"
        width="90%"
        height="160px"
        animation="wave"
        style={{ borderRadius: 4 }}
      />
      <Skeleton
        variant="rectangular"
        width="90%"
        height="160px"
        animation="wave"
        style={{ borderRadius: 4 }}
      />
      <Skeleton
        variant="rectangular"
        width="90%"
        height="160px"
        animation="wave"
        style={{ borderRadius: 4 }}
      />
      <Skeleton
        variant="rectangular"
        width="130%"
        height="160px"
        animation="wave"
        style={{ borderRadius: 4 }}
      />
    </Container>
  )
}
